/**
 * 请求相关的 composable
 * 用于设置 axios 请求头
 */

/**
 * 设置请求头
 * @param {string} key 请求头 key
 * @param {string} value 请求头 value
 */
export function setHeaders(key, value) {
	if (!import.meta.client) return;

	// 将 headers 存储到 localStorage，以便 axios 拦截器读取
	// 使用特定的 key 前缀，避免与其他数据冲突
	const storageKey = `app_${key.toLowerCase()}`;
	localStorage.setItem(storageKey, value);

	// 同时尝试设置到 axios 实例的默认 headers
	try {
		const nuxtApp = useNuxtApp();
		const axios = nuxtApp.$axios;

		if (axios && axios.defaults && axios.defaults.headers) {
			axios.defaults.headers.common[key] = value;
		}
	} catch (error) {
		// 如果 axios 还未初始化，只存储到 localStorage
		// axios 拦截器会从 localStorage 读取
	}
}

/**
 * 获取请求头
 * @param {string} key 请求头 key
 * @returns {string|null} 请求头 value
 */
export function getHeader(key) {
	if (!import.meta.client) return null;
	const storageKey = `app_${key.toLowerCase()}`;
	return localStorage.getItem(storageKey);
}
